import CartItemLayoutNew from './CartItemLayoutNew'

export default CartItemLayoutNew
